<template>
    <mdb-row class="mb-md-1">
		<mdb-col col="12">
			<button class="btn-wrapper" @click="TOGGLE_PANEL">
				<img src="/static/logo.png" height="135"/>
			</button>
		</mdb-col>
	</mdb-row>
</template>

<script>
import {mapMutations} from "vuex";

export default {
	name: 'Brand',
	methods: {
		...mapMutations(['TOGGLE_PANEL'])
	}
}
</script>

<style scoped>
.btn-wrapper {
	background: none;
	border: none;
	padding: 0;
}
</style>
